// extracted by extract-css-chunks-webpack-plugin
module.exports = JSON.parse("{\"lg\":\"1366\",\"md\":\"1080\",\"ml\":\"841\",\"sm\":\"720\",\"xs\":\"0\"}");